import { h } from 'preact';
import register from 'preact-custom-element';
import EmailForm from './components/form/email';
import { EmailFormProps } from './components/form/email/types';
import './scss/shared.scss';
import './scss/email.scss';

const SiteConfig: Record<string, EmailFormProps> = {
    mizkan: {
        privacyPolicy: '/fair-processing-notice/',
        consumerContactPages: {
            branston: {
                title: 'Branston',
                contactUrl: 'https://bringoutthebranston.co.uk/contact/',
            },
            sarsons: {
                title: 'Sarson’s',
                contactUrl: 'https://www.sarsons.co.uk/contact-us',
            },
            haywards: {
                title: 'Haywards',
                contactUrl: 'https://www.haywardspickles.co.uk/contact/',
            },
            osu: {
                title: 'Osu Vinegar',
                contactUrl: 'https://www.osuvinegar.co.uk/pages/contact',
            },
        },
        classNames: {
            button: {
                submit: 'btn  btn-primary',
            },
        },
    },
};

function Form({ site }: FormProps) {
    if (SiteConfig[site] === undefined) {
        throw new Error(`Invalid site config identifier "${site}"`);
    }

    return h(EmailForm, SiteConfig[site]);
}

type FormProps = {
    site: string,
};

register(Form, 'mizkan-email-form', ['site']);
